import { z } from 'zod';

export const SearchBarSchema = z
  .object({
    value: z.string().min(1),
  })
  .required();

export type SearchBarFormType = z.infer<typeof SearchBarSchema>;
